import YouTubeIframeLoader from 'youtube-iframe';
class PageVisual {
	constructor(config) {
		this.config = Object.assign({
			scope: '.page_visual'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((it, scope) => {
			this.initYT($(scope));
		})
	}


	initYT($scope) {
		let $player = $scope.find('.asset-wrapper.youtube .player');

		if ($player.length < 1) {
			return;
		}

		let youtubeId = $player.data('id');

		YouTubeIframeLoader.load(function (YT) {
			let player = new YT.Player($player[0], {
				height: '1080',
				width: '1920',
				videoId: youtubeId,
				playerVars: {
					loop: 1,
					autoplay: 1,
					controls: 0,
					mute: 1,
					rel: 0,
					playlist: youtubeId
				},
			});

			$('#play-video').on('click', (e) => {
				player.playVideo()
				$('#play-video').addClass('d-none')
				$('#stop-video').removeClass('d-none');
			});

			$('#stop-video').on('click', (e) => {
				player.pauseVideo()
				$('#play-video').removeClass('d-none');
				$('#stop-video').addClass('d-none')
			});
		});

	}
}

jQuery(window).on('load', function () {
	// html5-video-container"
	if (jQuery('#video_element_mobile').length > 0) {
		if (jQuery(window).width() > 992) {
			jQuery('#video_element_desktop').get(0).play();
		} else {
			jQuery('#video_element_mobile').get(0).play();
		}
	}
});


export default new PageVisual;